import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';

import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';

import { MatCheckboxModule } from '@angular/material/checkbox';

import { ActFormAutoCompleteModule } from '../../chipList/Act/Act.module';

import { ActTypeFormAutoCompleteModule } from '../../chipList/ActType/ActType.module';

import { ParametreDossierFormComponent } from './ParametreDossier.component';

@NgModule({
  declarations: [ParametreDossierFormComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,

    MatInputModule,
    MatSelectModule,

    MatCheckboxModule,

    ActFormAutoCompleteModule,

    ActTypeFormAutoCompleteModule
  ],
  exports: [
    ParametreDossierFormComponent,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,

    MatInputModule,
    MatSelectModule,

    MatCheckboxModule,

    ActFormAutoCompleteModule,

    ActTypeFormAutoCompleteModule
  ]
})
export class ParametreDossierFormModule {}
